import {put,takeLatest,call} from 'redux-saga/effects'
import * as userService from "../../../services/userService"
import {
    DELETE_USER,
    DELETE_USER_SUCCESS,
    DELETE_USER_ERROR
}
    from "../../actions/user"

function* deleteUserSaga(action) {
    try {
        yield call(userService.DeleteUser,action.payload)
        yield put({
            type: DELETE_USER_SUCCESS,
            payload: action.payload.uid
        })

    } catch(error) {
        yield put({
            type: DELETE_USER_ERROR,error: error.data
        })
    }
}

export function* deleteUserSagaWatcher() {
    yield takeLatest(DELETE_USER,deleteUserSaga)
}